import React from "react"
import { VictoryLabel } from "victory"
import PropTypes from "prop-types"

const LineGraphMessage = ({ message, width, height }) => (
  <VictoryLabel
    text={message}
    dy={-140}
    x={width / 2}
    y={height}
    textAnchor={"middle"}
    style={{
      fontSize: "18px",
      fill: "#999999",
      fontFamily: '"Inter", "sans-serif", "Arial"',
    }}
  />
)

LineGraphMessage.propTypes = {
  message: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
}

export default LineGraphMessage
